export const RULE_SET_TYPES = Object.freeze([
  "DOMESTIC",
  "INTERNATIONAL",
  "EMERGENCYONLY",
  "CUSTOM1",
  "CUSTOM2",
  "CUSTOM3",
]);

export const EMPTY_NORMALIZATION_RULE = Object.freeze({
  regExpr: "",
  replace: "",
});

export const EMPTY_RULE_SET = Object.freeze({
  normalizationRule: [EMPTY_NORMALIZATION_RULE],
  ruleSetType: "",
});

export const EMPTY_DIALPLAN = Object.freeze({
  name: "",
  internationalPrefix: "0",
  nationalPrefix: "0",
  countryCode: "0",
  ruleSet: [EMPTY_RULE_SET],
});

export const DURATION = 10000;

export const TABS = Object.freeze({
  CUSTOMER: "Customer-based Dial Plans",
  GLOBAL: "Global Dial Plans",
});
